import { Component, Input, OnInit } from '@angular/core';
import { ModalSettings } from '@app/services/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  constructor(private translateService: TranslateService) {}

  @Input('modalRef') public modalRef: BsModalRef<ModalSettings> | undefined;
  // title: string = 'dsadsa';

  ngOnInit(): void {
    // this.loadComponent();
    //this.title = this.modalRef?.content.title;
  }

  get title(): string {
    return this?.modalRef?.content?.title || '';
  }

  get closeLabel(): string {
    return (
      this?.modalRef?.content?.closeLabel ||
      this.translateService.instant('COMMON.BUTTON.CLOSE')
    );
  }

  close() {
    if (this.modalRef?.content?.onClose) {
      this.modalRef?.content.onClose('dismiss');
    }
    this.modalRef?.hide();
  }
}
